"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedskincare = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 41 52",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedskincare` : '') + (description ? ` desc-brandedskincare` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedskincare"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedskincare"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35 14.58c0-.83-.73-1.5-1.61-1.5H7.6c-.89 0-1.61.67-1.61 1.5v4.5h29v-4.5Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M36.28 19.02H4.73A4.74 4.74 0 0 0 0 23.77v26.65C0 51.3.7 52 1.57 52h37.86c.87 0 1.57-.7 1.57-1.58V23.77a4.74 4.74 0 0 0-4.73-4.75Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41 50.42V23.77a4.74 4.74 0 0 0-4.73-4.75h-1.45A112.78 112.78 0 0 1 0 46.8v3.63C0 51.3.7 52 1.57 52h37.85c.87 0 1.57-.7 1.57-1.58H41Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.57 0C22.35 7.3 9 7.31 9 11.37c0 1.62.79 1.62.79 1.62h22C36.49 7.31 26.29 0 21.57 0Z",
    fill: "#FFC599"
  }));
};
var _default = exports.default = brandedskincare;